import { Endpoint, Http } from "Application";
import { AppUrls } from "AppUrls";

export class RemoveDetailsRequest {
    public studentSessionId: Guid = "";
}

export class RemoveDetailsMentorStudentEndPoint extends Endpoint<RemoveDetailsRequest, Response> {
    constructor() {
        super();
        this.verb(Http.Put);
        this.path(AppUrls.Server.WeeklyRota.EditMentorStudentRota);
    }

    public async HandleRequestAsync(request: RemoveDetailsRequest): Promise<RemoveDetailsRequest> {
        return request;
    }

    public async HandleResponseAsync(response: Response[]): Promise<Response[]> {
        return response;
    }
}
